import { combineReducers } from 'redux';
const { firebaseReducer } = require('react-redux-firebase');

export interface Message {
  message: string;
  phoneNumbers: string[];
  status: 'created';
}

interface RsvpBase {
  attending: boolean;
  name: string;
  note: string;
  id?: string;
}

export interface RsvpYes extends RsvpBase {
  attending: true;
  phoneNumber: string;
  guestName: string;
  drinks: boolean;
  allergies: string;
  address: string;
}

export interface RsvpNo extends RsvpBase {
  attending: false;
}

export type Rsvp = RsvpYes | RsvpNo;

export interface RootState {
  // tslint:disable:no-any
  firebase: {
    auth: any;
    authError: any;
    profile: any;
    isInitializing: any;
    data: any;
  };
  // tslint:enable:no-any
}

export default combineReducers<RootState>({
  firebase: firebaseReducer,
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/root.ts